// Auto generated file, do not manually modify!
// com.hotpads.zcalendar.api.web.handler.TourSchedulingWebApiHandler

import type { UseMutationOptions } from '@zg-rentals/react-query5';
import { useMutation } from '@zg-rentals/react-query5';
import { tsClientOptions } from '@zg-rentals/react-query5';
import type { Client } from '@zg-rentals/http-client';
import { TourSchedulingWebApiHandler_rescheduleTourByIrene } from '@zg-rentals/ts-z-calendar-client';

import type { RescheduleTourByIreneWebApiRequestDto, TourWebApiDto } from '@zg-rentals/ts-z-calendar-client';

export interface TourSchedulingWebApiHandler_rescheduleTourByIrene_Args {
  postData: RescheduleTourByIreneWebApiRequestDto;
}

export type TourSchedulingWebApiHandler_rescheduleTourByIrene_Options = UseMutationOptions<
  TourWebApiDto,
  unknown,
  TourSchedulingWebApiHandler_rescheduleTourByIrene_Args
>;

/**
 * reschedule a tour (initiated by Irene)
 */
export const useTourSchedulingWebApiHandler_rescheduleTourByIrene = ({
  httpClient,
  ...options
}: Omit<TourSchedulingWebApiHandler_rescheduleTourByIrene_Options, 'mutationFn'> & { httpClient?: Client } = {}) => {
  return useMutation({
    ...tsClientOptions.mutationOptions,
    ...options,
    mutationFn: (args: TourSchedulingWebApiHandler_rescheduleTourByIrene_Args) =>
      TourSchedulingWebApiHandler_rescheduleTourByIrene(args.postData, httpClient),
  });
};
